$ = require 'jquery'
React = require 'react'
_ = require 'underscore'
{ unsplashApi, toJson } = require 'network/unsplash'
t = require('views/internal/recup-with-helpers')()
constants = require './constants'
helpers = require './helpers'

{ DEFAULT_COLLECTION_ID, PAGE_SIZE } = constants.Unsplash
{ createBackgroundStyle, createPhotoFromResponse } = helpers

module.exports = class PhotoChooserComponent extends React.Component
  displayName: 'PhotoChooserComponent'

  constructor: (props) ->
    @state =
      # XXX: duplicated state
      background: null

      hasMore: true
      isLoading: false
      page: 1
      photos: props.seedPhotos

    super props

  componentDidMount: ->
    @createObserver()
    @observeMarker()

    # Reload first page of results to reduce chance
    # of stale data resulting in duplicate photos
    @loadPhotos(1)

    setTimeout (=> @chooserElem?.focus()), 10

  componentDidUpdate: ->
    @observeMarker()

  render: t.renderable ->
    { background, hasMore, photos } = @state
    { selectedBackground } = @props

    setChooserElem = (elem) => @chooserElem = elem
    setLoadingElem = (elem) => @loadingElem = elem

    onBackgroundClick = (bg) =>
      # XXX: duplicated state
      @setState { background: bg }
      @props.onSelect bg

    t.div '.background-chooser', { ref: setChooserElem, tabIndex: 0 }, ->
      t.ul '.background-grid', ->
        photos.forEach (bg) ->
          isSelected = bg.value ==
            if background?
              background.value
            else
              selectedBackground.value

          t.li '.background-grid-item', ->
            t.button '.background-grid-trigger.is-photo', {
              className: t.classify { selected: isSelected }
              key: bg.value
              onClick: -> onBackgroundClick bg
              role: 'button'
              style: createBackgroundStyle bg
            }, ->
              if isSelected
                t.icon 'check'
      if hasMore
        t.div '.logo-loading.active', { ref: setLoadingElem }

  createObserver: =>
    if @observer? then return

    cb = (entries) =>
      entry = _.first(entries)
      if entry.isIntersecting || entry.intersectionRatio then @loadNextPage()

    @scrollContainerElem = $(@chooserElem).closest('.pop-over-content').get(0)
    @observer = new IntersectionObserver cb, { root: @scrollContainerElem }

  observeMarker: =>
    if !@observer? || !@loadingElem? then return

    @observer.disconnect()
    @observer.observe @loadingElem

  loadNextPage: =>
    if @state.isLoading then return

    nextPage = @state.page + 1
    @setState { page: nextPage }
    @loadPhotos nextPage

  loadPhotos: (page) =>
    @setState { isLoading: true }
    unsplashApi
      .collections
      .getCollectionPhotos DEFAULT_COLLECTION_ID, page, PAGE_SIZE, 'latest'
      .then toJson
      .then (photos) -> photos.map createPhotoFromResponse
      .then (photos) =>
        hasMore = photos.length == PAGE_SIZE
        photos = if page != 1 then @state.photos.concat photos else photos
        @setState { hasMore, isLoading: false, photos }



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/photo-chooser-component.coffee